/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * FacilityFlow API
 * Eine professionelle Web API für Facility Management mit Versionierung, Logging und Observability.
 * OpenAPI spec version: 1.0
 */
import { customInstance } from '../../mutator/custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  export const getDemoData = () => {
/**
 * @summary Re-creates the date-dependent demo data (time clock, planning, absences, checklist
protocol) relative to today. Users, customers and objects stay as they are.
 */
const postApiV1DemoDataRefresh = (
    
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/demo-data/refresh`, method: 'POST'
    },
      options);
    }
  /**
 * @summary Puts all demo data, including the seed users, back to the seed state. Signed-in demo
users lose their session; the demo tenant's settings are kept.
 */
const postApiV1DemoDataReset = (
    
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/demo-data/reset`, method: 'POST'
    },
      options);
    }
  return {postApiV1DemoDataRefresh,postApiV1DemoDataReset}};
export type PostApiV1DemoDataRefreshResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDemoData>['postApiV1DemoDataRefresh']>>>
export type PostApiV1DemoDataResetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDemoData>['postApiV1DemoDataReset']>>>
